import { MaterialModule } from './../modules/material.module';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EqpLookupComponent } from './eqp-lookup/eqp-lookup.component';
import { DynamicLoaderDirective } from './dynamic-loader/dynamic-loader.directive';
import { EqpTourComponent } from './eqp-tour/eqp-tour.component';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { CopyPasteDirective } from './CopyPasteBlocker/copy-paste-blocker.directive';
import { ImportExportComponent } from './import-export/import-export.component';
import { EqpFiltersModule } from '@eqproject/eqp-filters';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgSelectModule,
        CommonModule,
        GuidedTourModule,
        EqpFiltersModule
    ],
    exports: [
        EqpLookupComponent,
        DynamicLoaderDirective,
        EqpTourComponent,
        CopyPasteDirective,
        ImportExportComponent,
        EqpFiltersModule
    ],
    declarations: [
        EqpLookupComponent,
        DynamicLoaderDirective,
        EqpTourComponent,
        CopyPasteDirective,
        ImportExportComponent
    ],
    providers: [
        GuidedTourService
    ]
})
export class DirectivesModule { }
